import { useEffect, useState } from "react";
import { auth } from "../lib/apteva";
import { Link } from "../lib/router";
import { campaignProperties } from "../lib/campaign";

export function Register() {
  const [username, setUsername] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [verification, setVerification] = useState<null | boolean>(null);
  useEffect(() => { campaignProperties(); }, []);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");

    if (username.length < 3) { setError("Username must be at least 3 characters"); return; }
    if (password.length < 8 || password.length > 128) { setError("Password must contain 8 to 128 characters"); return; }
    if (password !== confirmPassword) { setError("Passwords do not match"); return; }

    setLoading(true);

    try {
      const result = await auth.register({
        username, email, password,
        display_name: displayName || undefined,
      });
      (window as any).apa?.("socialcast_signup_completed", { ...campaignProperties(), verification_required: Boolean(result.verification_required) });
      (window as any).socialcastAds?.trackRegistration();
      if (result.autoLogin) { window.location.href = "/dashboard"; return; }
      setVerification(Boolean(result.verification_email_enabled));
    } catch (err: any) {
      setError(err.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  }

  const inputClass = "w-full px-3.5 py-2.5 border border-stone-300 dark:border-zinc-700 rounded-xl bg-white dark:bg-zinc-800/50 text-stone-900 dark:text-white placeholder-stone-400 dark:placeholder-zinc-600 focus:outline-none focus:ring-2 focus:ring-orange-500/40 focus:border-orange-500 dark:focus:border-orange-500 transition-colors";

  return (
    <div className="min-h-[80vh] flex items-center justify-center">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl items-center justify-center mb-4">
            <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-stone-900 dark:text-white">Create Account</h2>
          <p className="text-sm text-stone-500 dark:text-zinc-500 mt-1">Get started with SocialCast</p>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-50 dark:bg-red-500/10 text-red-700 dark:text-red-400 rounded-xl text-sm border border-red-200/60 dark:border-red-500/20">{error}</div>
        )}

        {verification !== null ? <div role="status" className="space-y-4 text-sm text-stone-700 dark:text-zinc-300">
          <h3 className="text-lg font-semibold">Account created</h3>
          <p>{verification ? "Check your email to verify your account before signing in." : "Email verification is required before you can sign in. Automatic verification emails are currently unavailable."}</p>
          {!verification && <a className="text-orange-600 dark:text-orange-400 underline" href="mailto:contact@socialcast.dev">Contact support to complete setup</a>}
        </div> : <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-stone-700 dark:text-zinc-300 mb-1.5">Username</label>
            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="johndoe" className={inputClass} required />
          </div>

          <div>
            <label className="block text-sm font-medium text-stone-700 dark:text-zinc-300 mb-1.5">
              Display Name <span className="text-stone-400 dark:text-zinc-600">(optional)</span>
            </label>
            <input type="text" value={displayName} onChange={(e) => setDisplayName(e.target.value)} placeholder="John Doe" className={inputClass} />
          </div>

          <div>
            <label className="block text-sm font-medium text-stone-700 dark:text-zinc-300 mb-1.5">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className={inputClass} required />
          </div>

          <div>
            <label className="block text-sm font-medium text-stone-700 dark:text-zinc-300 mb-1.5">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className={inputClass} required />
            <p className="mt-1 text-xs text-stone-400 dark:text-zinc-600">8 to 128 characters</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-stone-700 dark:text-zinc-300 mb-1.5">Confirm Password</label>
            <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="••••••••" className={inputClass} required />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2.5 px-4 bg-orange-500 text-white rounded-xl font-semibold hover:bg-orange-600 disabled:opacity-50 transition-all"
          >
            {loading ? "Creating account..." : "Create Account"}
          </button>
        </form>}

        <p className="mt-6 text-center text-sm text-stone-500 dark:text-zinc-500">
          Already have an account?{" "}
          <Link href="/login" className="text-orange-600 dark:text-orange-400 hover:text-orange-700 dark:hover:text-orange-300 font-semibold">
            Sign In
          </Link>
        </p>
      </div>
    </div>
  );
}
